import { Square, SquareCheckBig, SquareX, type LucideIcon } from 'lucide-react';

/** Task icons that follow the task's status (#324): open until done, crossed when cancelled. */
export type TaskIconKind = 'open' | 'done' | 'cancelled';

export const TASK_ICONS: Record<TaskIconKind, LucideIcon> = { open: Square, done: SquareCheckBig, cancelled: SquareX };

export function taskIconKind(status: string | null | undefined): TaskIconKind {
  return status === 'done' || status === 'cancelled' ? status : 'open';
}

/** Done and cancelled tasks are closed; Mark incomplete reopens them. */
export const isTaskClosed = (status: string | null | undefined) => taskIconKind(status) !== 'open';
